<div class="fc-quick-chips">
  <button
    *ngFor="let r of ranges"
    type="button"
    class="fc-chip"
    [class.fc-chip--active]="activeKey === r.key"
    (click)="select(r)"
  >{{ r.label }}</button>
</div>
